import React from "react"
import { useField } from "formik"

import { TokenAmountInput, TokenAmountInputProps } from "#/ui/Input"

export type FieldAmountInputProps = {
  fieldName: string
} & Omit<TokenAmountInputProps, "onChange" | "value" | "balanceToken"> & {
    balanceToken: bigint
  }

export default function FieldAmountInput({
  fieldName,
  balanceToken,
  tokenDecimals,
  ...props
}: FieldAmountInputProps) {
  const [field, meta, helpers] = useField<bigint>(fieldName)

  return (
    <TokenAmountInput
      {...props}
      {...field}
      value={meta.value}
      tokenDecimals={tokenDecimals}
      balanceToken={balanceToken}
      error={Boolean(meta.error)}
      errorMessage={meta.error}
      onChange={(changedValue) => helpers.setValue(changedValue)}
    />
  )
}
